const data = [
	{
		en: "Empty land",
		ar: "تقييم ايجار أرض فضاء",
		value: 2020,
		propertyTypes: [ 0 ]
	},
	{
		en: "Single residential villa",
		ar: "تقييم فيلا سكنية واحدة",
		value: 2020,
		propertyTypes: [ 4 ]
	},
	{
		en: "Residential Flat",
		ar: "تقييم شقة سكنية",
		value: 2020,
		propertyTypes: [ 2 ]
	},
	{
		en: "Office, Shop or Showroom commercial",
		ar: "تقييم مكتب أو محل أو معرض تجاري",
		value: 2020,
		propertyTypes: [ 2 ]
	},
	{
		en: "Agricultural land along with any associated buildings on the single plot",
		ar: "تقييم أرض زراعية  مزروعة مع أي مباني على الأرض",
		value: 2020,
		propertyTypes: [ 0 ]
	},
	{
		en: "Valuation   of (Commercial Building or Villa Complex or Industrial Building or Labor Accommodation and land on a single plot",
		ar: "تقييم) مبنى تجاري أو مجمع فلل أو مبنى صناعي أو سكن عمال مقام على أرض واحدة(",
		value: 10020,
		propertyTypes: [ 1, 4 ]
	},
	{
		en: "Hotel valuation or Hotel Apartments",
		ar: "تقييم مبنى فندق أو شقق فندقية",
		value: 10020,
		propertyTypes: [ 1, 2 ]
	},
];

export default data;
